import { formatDistanceToNow, parseISO, format } from 'date-fns';
enum DateFormat {
  EU = 'dd/mm/yyyy',
  US = 'mm/dd/yyyy',
}

export function convertDateToFormat(date: string, format: DateFormat = DateFormat.EU): string {
  const dateObj = new Date(date);
  const day = String(dateObj.getDate()).padStart(2, '0');
  const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
  const year = dateObj.getFullYear();

  switch (format) {
    case DateFormat.EU:
      return `${day}/${month}/${year}`;
    case DateFormat.US:
      return `${month}/${day}/${year}`;
    default:
      throw new Error(`Unknown date format: ${format}`);
  }
}

export function getCurrentTimestamp(): string {
  const date = new Date();
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
  const year = date.getFullYear();
  const ampm = hours >= 12 ? 'pm' : 'am';
  const hours12 = hours > 12 ? hours - 12 : hours;

  return `${hours12}:${minutes} ${ampm} ${day}/${month}/${year}`;
}

export const formatDateToNow = (dateString: string): string => {
  const date = parseISO(dateString);
  return formatDistanceToNow(date, { addSuffix: true });
};

export function formatDateHistoryTable(dateString: string): string {
  const date = new Date(dateString);

  const day = date.getUTCDate();
  const month = date.getUTCMonth() + 1;
  const year = date.getUTCFullYear().toString().slice(-2);

  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes().toString().padStart(2, '0');

  const isAM = hours < 12;
  const formattedHours = hours % 12 || 12;
  const ampm = isAM ? 'am' : 'pm';

  return `${day}/${month}/${year} - ${formattedHours}:${minutes} ${ampm}`;
}

export const residualsDateFormatter = (date: string | Date): string => {
  if (!date) return '-';

  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date;
    if (isNaN(dateObj.getTime())) return '-';

    return format(dateObj, 'd MMM yyyy');
  } catch {
    return '-';
  }
};
